<template>
    <div>
        <div v-if="!loading" class="home-pag">
          <!-- header Start-->
          <section class="event header" id="home">
              <div class="header3 bg">
                  <div class="event-content">
                      <div class="container">
                          <div class="row">
                              <div class="col-md-12">
                                  <div class="center-text p-0 m-0">
                                      <!--div class="text-centerx"  style="border: 1px solid black;"-->
                                          <div class="row w-100">
                                            <div class="col-md-7 text-center" valign="middle">
                                              <p align="center">
                                                <img style="height: 100px " alt="" class="img-fluid" src="../../theme-assets/images/logo/result_inauguration.png">
                                                <br/><br/>
                                                <img style="height:60px; width:550px" alt="" class="img-fluid" src="../../theme-assets/images/logo/cu_admission_test_omegle.png">
                                              </p>
                                            </div>
                                            <div class="col-md-5 my-auto" style="vertical-align:middle;">
                                              <p align="center">
                                                <a v-if="startBtn" class="btn btn-lg btn-outline btn-default back-white border-not m-1" @click="openKeyModal('start')">
                                                  <span class="">Publish Detail Result</span>
                                                </a>
                                                <a v-if="postpondBtn" class="btn btn-default back-white border-not m-1" @click="openKeyModal('postpond')">
                                                  <span class="">Postpond Detail Result</span>
                                                </a>
                                              </p>
                                            </div>
                                          </div>
                                      <!--/div-->
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  
              </div>
          </section>
        </div>
        <div v-else>
            <loader class="loader"></loader> <br />
        </div>
        <div class="tap-top">
            <div><i v-on:click="topFunction()" class="fa fa-angle-double-up"></i></div>
        </div>
        <b-modal id="keyModal" size="md" hide-footer>
          <template #modal-title>
            Security Pass Key
          </template>
          <form v-on:submit.prevent="onKeySubmit">

          <div class="modal-body">
              <!-- <section class="register-page section-b-spacex ng-star-inserted"> -->

                  <div class="container padding-cls">
                      <div class="checkout-page">
                          <div class="checkout-form theme-form">
                              <div class="row center-content">
                                  <div class="col-lg-12 col-sm-12 col-xs-12">
                                      <div class="theme-card check-out ng-star-inserted">
                                          <div class="row">
                                              <div class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:20px">
                                                  <div class="field-label">Security Key</div>
                                                  <div class="input-group flex-nowrap">
                                                      <input type="password" class="form-control" name="key" value="" placeholder="Key" aria-label="Key" aria-describedby="addon-wrapping" autocomplete="off" v-model="registrationForm.key" required>
                                                  </div>
                                                  <!-- <input type="text" name="phone" value="" placeholder="Mobile No." autocomplete="off" class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.mobile" required> -->
                                                  <!-- <div v-if="hscRoll==0" class="text text-danger ng-star-inserted">HSC Roll is required.</div> -->
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              <!-- </section> -->
              
          <button class="btn info-btn btn-info radius-1" style="width:100%" type="submit" block>Submit</button>

          </div>
          
      </form>
          <!-- <b-button class="mt-3" @click="onSubmit" type="submit" block >Submit</b-button> -->
          <!-- @click="$bvModal.hide('bv-modal-example')" -->
        </b-modal>
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
import { INAUGURAL_BUTTONS, POST_INAUGURAL } from '../../const/api'
import { GET } from '../../utils/Request'

export default {
  name: 'ResultInaugural',
  components: { Loader },
  data() {
    return {
        loading: true,
        firstTimeLoad: true,
        startBtn:true,
        postpondBtn:false,
        action:'start',
        registrationForm:{
          key:''
        }
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getLaunchButtons();
    this.timeoutForLoading();
  },
  mounted() {   
  },
  methods: {
    async getLaunchButtons(){
      let response = await GET(INAUGURAL_BUTTONS);
      
      /*console.log(response);*/

      if(response.status=='200'){
        if(response.data.buttonStart){
          this.startBtn = true;
        }else{
          this.startBtn = false;

        }
        if(response.data.buttonPostpond){
          this.postpondBtn = true;
        }else{
          this.postpondBtn = false;
        }
      }
      this.action = '';
    },
    openKeyModal(action){
      this.action = action;
      this.$bvModal.show('keyModal');
    },
    async onKeySubmit(event){
      // this.startBtn=false;
      //           this.launchBtn=true;
      //           console.log(this.registrationForm);
      
      this.$bvModal.hide('keyModal');

      //           return false;
      event.preventDefault();
      let response = null;
      response = await GET(POST_INAUGURAL+ this.registrationForm.key+'&action='+this.action);
      if(response.status=='200'){
        let type = response.data.status;
        // let code = response.data.code;
        let msg = response.data.message;
            if(type=='success'){
                this.startBtn=false;
                this.postpondBtn=true;
                this.registrationForm.key = '';
                this.$iziToast.success({
                   // title: 'Success',
                    message: msg
                });
                this.getLaunchButtons();
                this.$bvModal.hide('keyModal');
            }else{
                if(type=='info'){
                    this.startBtn=true;
                    this.postpondBtn=false;
                    
                    this.$iziToast.info({
                     //   title: 'Info',
                        message: msg
                    });
                

                }else{
                    this.$iziToast.error({
                      //  title: 'Error',
                        message: msg
                    });
                }
            }
        }else{
            this.$iziToast.error({
                // title: 'Error',
                message: 'Something Went Wrong. Please try again.'
            });
        }
      },
    
    goForUrl(url) {
      this.$router.replace(url)
    },
    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false
            }.bind(this),
            1000
          )
        })
      }
      this.firstTimeLoad = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:182.5vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
	 box-sizing: border-box;
}

</style>
